import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 发现-模块
 */

var find = {
  path: '/find',
  redirect: '/find/index',
  name: 'Find',
  component: BasicLayout,
  children: [{
    path: '/find',
    name: 'FindIndex',
    component: function component() {
      return import('views/find/Index');
    },
    meta: {
      title: '发现',
      keepAlive: true
    }
  }]
};
export default find;